import styled from 'styled-components';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';
import { screen } from '@/helpers/screen';

export const FAQLayout = styled.div`
  display: block;

  ${screen.lg} {
    display: grid;
    grid-template-columns: minmax(0, 5fr) minmax(0, 7fr);
    gap: 0 clamp(32px, 6vw, 88px);
    align-items: start;
  }

  h2 {
    text-align: left;
    margin: 0 0 var(--gap-h2, 56px);

    ${screen.lg} {
      position: sticky;
      top: 32px;
      margin: 0;
    }
  }
`;

export const FAQList = styled.div`
  details {
    border-top: 1px solid rgb(${getToken('color-background-tertiary')});
  }

  details:last-child {
    border-bottom: 1px solid rgb(${getToken('color-background-tertiary')});
  }

  summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    padding: 22px 0;
    list-style: none;
    cursor: pointer;
  }

  summary::-webkit-details-marker {
    display: none;
  }

  summary::after {
    content: '+';
    flex: none;
    font: 500 28px/1 ${getToken('font-family-title')};
    color: rgb(${getToken('color-success-60')});
    transition: transform 0.15s;
  }

  details[open] summary::after {
    transform: rotate(45deg);
  }

  h3 {
    margin: 0;
    font: 700 20px/1.4 ${getToken('font-family-default')};
    color: rgb(${getToken('color-primary-60')});
  }

  p {
    max-width: 608px;
    margin: 0 0 24px;
    font: 400 17px/1.75 ${getToken('font-family-default')};
    color: rgb(${getToken('color-text-primary')});
  }
`;
